import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import api from '@/utils/httpClient';
import { RequestPatientDto, RequestPatientForManipulationDto } from './createPatient';

export const updatePatient = (id: string, data: RequestPatientForManipulationDto) => {
  return api
    .put(`/api/patients/${id}`, data)
    .then((response) => (response.data as ApiResponse<RequestPatientDto>).data);
};
